// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"LocationHeader_productDetailHeader__8fECT","customIcon":"LocationHeader_customIcon__p54Gu","customBackIcon":"LocationHeader_customBackIcon__pAe8C"};